import styled, { keyframes } from "styled-components";

const fadeOut = keyframes`
  0% { opacity: 1; }
  70% { opacity: 1; }
  100% { opacity: 0; }
`;

export const SyncIconWrapper = styled.span`
  position: relative;
  display: inline-block;
  width: 32px;
  height: 25px;
  vertical-align: middle;
`;

export const SyncSpinnerPosition = styled.span`
  position: absolute;
  top: 5px;
  left: 12px;
`;

export const SyncSuccessMessage = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
  padding: 6px 14px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  animation: ${fadeOut} 3s forwards;
`;

export const BaseButton = styled.button`
  color: white;
  border-radius: 4px;
  padding: 0 10px;
  cursor: pointer;
  outline: none;
  width: 100%;
  margin-bottom: 8px;
`;

export const PopUpContainer = styled.div`
  position: fixed;
  background-color: #1f1e1e88;
  z-index: 2000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const PopUpBox = styled.div`
  background-color: white;
  width: 500px;
  margin: 13% auto;
  border-radius: 4px;
  padding: 16px;
  position: relative;
`;
